export default [


    {
        path: '/ccjtXmsbApplyInfo',
        name: 'ccjtXmsbApplyInfo',
        component: () => import('@/modules/ccjt/ccjtXmsbApplyInfo/PageList'),
        meta: {
            title: '项目申请记录',
            isBlack: false
        },
    },


    {
        path: '/flowFormExtendConfig',
        name: 'flowFormExtendConfig',
        component: () => import('@/modules/ccjt/flowFormExtendConfig/PageList'),
        meta: {
            title: '流程表单扩展内容',
            isBlack: true
        },
    },



    {
        path: '/ccjtProjectInfo',
        name: 'ccjtProjectInfo',
        component: () => import('@/modules/ccjt/ccjtProjectInfo/PageList'),
        meta: {
            title: '项目发布',
            isBlack: true
        },
    },

    {
        path: '/ccjtProjectSb',
        name: 'ccjtProjectSb',
        component: () => import('@/modules/ccjt/ccjtXmsbApplyInfo/PageProjectList.vue'),
        meta: {
            title: '孵化项目申报',
            isBlack: true
        },
    },


    {
        path: '/MyZlxxApply',
        name: 'PageTasks',
        component: () => import('@/modules/flowable/myTask/zlxx/MyXmsbApply.vue'),
        meta: {
            title: '我的待办',
            isBlack: true
        },
    },

    {
        path: '/MyZlxxTask',
        name: 'PageTasks',
        component: () => import('@/modules/flowable/myTask/zlxx/MyXmsbTask.vue'),
        meta: {
            title: '我的待办',
            isBlack: true
        },
    },
    {
        path: '/MyZlxxDone',
        name: 'PageTasks',
        component: () => import('@/modules/flowable/myTask/zlxx/MyXmsbDone.vue'),
        meta: {
            title: '我的已办',
            isBlack: true
        },
    },

    {
        path: '/ZlxxDetailForWeb',
        name: 'ZlxxDetailForWeb',
        component: () => import('@/modules/ccjt/ccjtXmsbApplyInfo/DetailForWeb.vue'),
        meta: {
            title: '申报详情',
            isBlack: false,
            needLogin: false,
            fullscreen: true,
        },
    },



]
